import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Mixpanel from "utils/mixpanel";
import { PATHS } from "constants/pathConstants";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";
import {
  selectExistingOrdersWithoutCancelled,
  selectTestKitsGLIsCurrentlyOffering
} from "store/reducers/order/OrderInformationSlice";
import { selectAllPreviousSurveyAnswers } from "store/reducers/survey/SurveySlice";
import { figureOutKitsToOfferMemberRightNow } from "utils/v3/testKitUtils";
import { combineArrayOfWordsWithCommasAndAnAndForLastItem } from "utils/utils";
import BalanceIcon from "assets/images/BalanceIcon.svg";
import WelcomeHero from ".";

type RequestTestsHeroProps = {};

const RequestTestsHero: React.FC<RequestTestsHeroProps> = () => {
  const history = useHistory();
  const userInformation = useSelector(selectUserPersonalInformation);
  const previousSurveyAnswers = useSelector(selectAllPreviousSurveyAnswers);
  const kitsAlreadyOrdered = useSelector(selectExistingOrdersWithoutCancelled);
  const kitsGLCurrentlyOffers = useSelector(
    selectTestKitsGLIsCurrentlyOffering
  );
  const kitsToOfferMemberRightNow = figureOutKitsToOfferMemberRightNow(
    kitsGLCurrentlyOffers,
    kitsAlreadyOrdered,
    previousSurveyAnswers,
    "",
    userInformation.glProgramId
  );
  const greetingName =
    userInformation.preferredName ?? userInformation.firstName ?? "";
  const onActionClick = useCallback(() => {
    Mixpanel.track("To Do Card CTA Clicked - Order recommended kits");
    history.push(PATHS.ORDER_KIT_SELECTION);
  }, [history, Mixpanel, PATHS]);
  const hasMultipleKitsToOffer = kitsToOfferMemberRightNow?.length > 1;
  const testNamesArray = kitsToOfferMemberRightNow.map((kit) => {
    return kit.test_name;
  });
  const testNamesString = combineArrayOfWordsWithCommasAndAnAndForLastItem(
    testNamesArray
  );
  const testsText = hasMultipleKitsToOffer ? "Tests" : "Test";
  const testsTextLowercase = testsText.toLowerCase();

  return (
    <WelcomeHero
      contentButtonText={`Request DNA ${
        hasMultipleKitsToOffer ? "Screenings" : "Screening"
      }`}
      contentHeaderText={`Request Your ${testsText}`}
      contentSubText={`Good to see you again, ${greetingName}!`}
      contentParagraphText={`Based on what you've shared, the ${testNamesString} ${testsTextLowercase} have been suggested`}
      headerIcon={BalanceIcon}
      headerSubText={`Based on what you've shared, the ${testNamesString} ${testsTextLowercase} have been suggested`}
      headerText={`Request Your ${testsText}`}
      id="request-tests-hero"
      onActionClick={onActionClick}
    />
  );
};

export default RequestTestsHero;
